var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 14.2929C10.6834 13.9024 11.3166 13.9024 11.7071 14.2929L15 17.5858L15 5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5L17 17.5858L20.2929 14.2929C20.6834 13.9024 21.3166 13.9024 21.7071 14.2929C22.0976 14.6834 22.0976 15.3166 21.7071 15.7071L16.7071 20.7071C16.3166 21.0976 15.6834 21.0976 15.2929 20.7071L10.2929 15.7071C9.90237 15.3166 9.90237 14.6834 10.2929 14.2929Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4.55228 18 5 18.4477 5 19V24C5 25.1046 5.89543 26 7 26H25C26.1046 26 27 25.1046 27 24V19C27 18.4477 27.4477 18 28 18C28.5523 18 29 18.4477 29 19V24C29 26.2091 27.2091 28 25 28H7C4.79086 28 3 26.2091 3 24V19C3 18.4477 3.44772 18 4 18Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.bcf1a97384058d7e349c98e9b7fd3d83.svg";
export { ForwardRef as ReactComponent };